import { LoginOptionsConfiguration } from "@remo-co/types";
import { createSelector } from "reselect";
import { RootState } from "store";

const selectCompanySettings = (state: RootState) => state.companySettings;

const makeSelectExitDoorUrl = createSelector(
  selectCompanySettings,
  (substate) => substate.exitURL,
);

const selectDisableVPNCheck = createSelector(
  selectCompanySettings,
  (substate) => substate.disableVPNCheck,
);

const selectCompanyBadgeUrl = createSelector(
  selectCompanySettings,
  (substate) => substate.companyBadgeURL,
);

const selectEnableCompanyBadge = createSelector(
  selectCompanySettings,
  (substate) => substate.enableCompanyBadge,
);

const makeSelectOnboardDefaults = createSelector(
  selectCompanySettings,
  ({ defaultOnboardText, defaultOnboardMedia }) => ({
    defaultOnboardMedia,
    defaultOnboardText,
  }),
);

const makeSelectBoardProvider = createSelector(
  selectCompanySettings,
  ({ boardProvider }) => boardProvider,
);

const selectCompanySettingsFeatureToggles = createSelector(
  selectCompanySettings,
  ({ disabledFeatures }) => disabledFeatures ?? [],
);

const makeSelectIsDirectoryVisibleToAssistants = createSelector(
  selectCompanySettings,
  ({ isDirectoryVisibleToAssistants }) => isDirectoryVisibleToAssistants,
);

const selectLoginOptionsConfiguration = createSelector(
  selectCompanySettings,
  (state): LoginOptionsConfiguration => state.loginOptions,
);

export {
  selectCompanySettings,
  makeSelectExitDoorUrl,
  selectDisableVPNCheck,
  selectCompanyBadgeUrl,
  selectEnableCompanyBadge,
  makeSelectOnboardDefaults,
  makeSelectBoardProvider,
  selectCompanySettingsFeatureToggles,
  makeSelectIsDirectoryVisibleToAssistants,
  selectLoginOptionsConfiguration,
};
